module.exports = __webpack_public_path__ + "img/texture.fd50a431.png";